var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.backgroundImage,style:({
    height: `${_vm.size}px`,
    width: `${_vm.size}px`,
    position: `${_vm.positionRelative ? 'relative' : ''}`,
  })},[_c('img',{staticClass:"ability-image",attrs:{"height":_vm.size,"width":_vm.size,"src":_vm.getAbilityPath(_vm.icon),"alt":_vm.ability}}),(_vm.isUltimate)?_c('div',{staticClass:"ultimate"}):_vm._e(),(_vm.level)?_c('div',{staticClass:"level-container",class:_vm.backgroundImage},[_c('span',{staticClass:"level-icon",class:_vm.levelColor},[_vm._v(_vm._s(_vm.level))])]):_vm._e(),(_vm.level)?_c('div',{class:_vm.strokeColor}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }